"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMergedProps = void 0;
var useMergedProps = function (props, defaults) {
    var className = props.className, qaProp = props["data-qa"], style = props.style, incomingProps = __rest(props, ["className", "data-qa", "style"]);
    var _gkComponentIdentifier = defaults._gkComponentIdentifier, defaultClass = defaults.className, defaultQaProp = defaults["data-qa"], defaultStyle = defaults.style, defaultProps = __rest(defaults, ["_gkComponentIdentifier", "className", "data-qa", "style"]);
    var result = __assign(__assign({ className: [_gkComponentIdentifier, defaultClass, className]
            .filter(function (x) { return x; })
            .join(" "), "data-qa": qaProp || defaultQaProp || _gkComponentIdentifier, style: props.style || defaults.style
            ? Object.assign({}, defaultStyle, style)
            : undefined }, defaultProps), incomingProps);
    return result;
};
exports.useMergedProps = useMergedProps;
